import styled from '@emotion/styled';
import { Modal } from '@ui-components/neo.tax';

export const StyledModal = styled(Modal)({
  width: 500,
  '.modal-children-panel': { width: '50%', maxWidth: '512px' },
});
